import React from 'react';
import { AddressProps, CompareGridContextProps, MyAddressContextProps } from './types';

export const MyAddressContext = React.createContext<MyAddressContextProps|null>(null);

export const CompareGridContext = React.createContext<CompareGridContextProps|null>(null);